module.exports = "/_next/static/images/contact-a5a0d59d9ab19ff394497f25ed24f766.svg";